import React from 'react';

/**
 * Graphe en barres du chiffre d'affaires des 6 derniers mois.
 * data : [{ month: 'juil.', revenue: 129.9 }, ...]
 */
const RevenueChart = ({ data }) => {
    const hasData = Array.isArray(data) && data.some((d) => d.revenue > 0);

    if (!data || data.length === 0) {
        return (
            <div className="rounded-xl bg-white p-6 shadow-lg">
                <h3 className="mb-6 text-lg font-bold text-gray-800">Chiffre d'affaires (6 mois)</h3>
                <div className="flex h-64 items-center justify-center text-gray-500">
                    Pas encore de données de revenus
                </div>
            </div>
        );
    }

    const maxRevenue = Math.max(...data.map((d) => d.revenue), 1);

    return (
        <div className="rounded-xl bg-white p-6 shadow-lg">
            <div className="mb-6 flex items-baseline justify-between">
                <h3 className="text-lg font-bold text-gray-800">Chiffre d'affaires (6 mois)</h3>
                {!hasData && (
                    <span className="text-xs text-gray-400">en attente des 1res ventes</span>
                )}
            </div>

            <div className="flex h-64 items-end justify-between gap-3">
                {data.map((item, index) => {
                    const heightPercentage = (item.revenue / maxRevenue) * 100;
                    const isLast = index === data.length - 1;
                    return (
                        <div key={index} className="group flex flex-1 flex-col items-center gap-2">
                            <span className="text-xs font-semibold text-gray-700 opacity-0 transition-opacity group-hover:opacity-100">
                                {item.revenue.toFixed(0)}€
                            </span>
                            <div className="flex w-full flex-1 items-end">
                                <div
                                    className={`w-full rounded-t-lg transition-all duration-700 ease-out ${isLast
                                        ? 'bg-gradient-to-t from-emerald-600 to-emerald-400'
                                        : 'bg-gradient-to-t from-teal-500 to-teal-300'
                                        }`}
                                    style={{ height: `${Math.max(heightPercentage, 2)}%` }}
                                    title={`${item.month} : ${item.revenue.toFixed(2)}€`}
                                />
                            </div>
                            <span className="text-xs font-medium capitalize text-gray-500">
                                {item.month}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default RevenueChart;
